import React from "react";
import { useParams, Link } from "react-router-dom";
import image9 from "../Assets/image9.jpeg";
import Headers from "../Components/Headers";
import Footer from "../Components/Footers";

const workshopDetails = {
  1: {
    number: "WORKSHOP 1",
    title: "Threading with Kefir",
    image: image9, // put this image in public/images
    paragraphs: [
      <>
        <strong>Threading with Kefir</strong> is a hands-on, sensorial workshop
        exploring the living, generative possibilities of kefir cultures as
        collaborators in craft and storytelling. Participants work with active{" "}
        <span className="underline">kefir grains</span>—symbiotic colonies of
        bacteria and yeast—to braid, weave, and shape strands of fermented
        material into small tactile artefacts.
      </>,
      <>
        This workshop invites you to touch, smell, and observe the subtle
        transformations of a biome that is constantly in motion. Through
        threading, we learn to follow kefir’s rhythms: its elasticity, its
        resistance, and its unexpected ways of growing. Each gesture becomes a
        negotiation between human intention and microbial agency.
      </>,
      <>
        Alongside practice, we reflect on the cultural and ecological histories
        embedded in fermented foods, sharing stories of care, kinship,
        migration, and the long lineage of fermentation as a feminist,{" "}
        <span className="underline">intergenerational</span>, and domestic
        technology.
      </>,
      <>
        By the end of the session, you will leave with your own braided kefir
        form—a living object that will continue to shift and ferment, and
        continue to live with you, if you let it.
      </>,
    ],
  },
};

// Fallback content if id not found (default to 1)
const getWorkshop = (id) => {
  if (workshopDetails[id]) return workshopDetails[id];
  return workshopDetails[1];
};

const DescriptionPage = () => {
  const { id } = useParams();
  const workshop = getWorkshop(id);

  return (

    <>
    <Headers/>
    <div className="description-page">
      <div className="description-container">
        <h1 className="description-workshop-number">{workshop.number}</h1>

        <div className="description-image-wrapper">
          <img
            src={workshop.image}
            alt={workshop.title}
            className="description-image"
          />
        </div>

        <h2 className="description-title">
          <strong>{workshop.title}</strong>
        </h2>

        <div className="description-body">
          {workshop.paragraphs.map((para, idx) => (
            <p key={idx}>{para}</p>
          ))}
        </div>

        <div className="description-back-link">
          <Link to="/workshops">← Back to workshops</Link>
        </div>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default DescriptionPage;
